export default "<ion-app>\n  <!-- <app-notification></app-notification> -->\n  <ion-router-outlet></ion-router-outlet>\n</ion-app>\n"